import { useFormik } from "formik";
import { useEffect, useContext, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import DeleteComponents from "../../../../common/components/DeleteComponents";
import NoDataMsg from "../../../../common/components/NoDataMsg";
import AuthContext from "../../../../contexts/authContext";
import useDarkMode from "../../../../hooks/useDarkMode";
import useSortableData from "../../../../hooks/useSortableData";
import AlertService from "../../../../services/AlertService";
import { downloadExcel, convertJsonToPdf, downloadFile } from "../../../../services/ExportService";
import { getLicenseKey } from "../../../../services/application.settings";
import { updateFilter, getColumnsForDataTable, updateColumnsForDataTable } from "../../../../services/common.service";
import { getFeeType, addFeeType, updateFeeType, deleteFeeType } from "../../../../services/fee.service";
import { showLoader, TableLoader } from "../../../../services/loader.services";
import { toasts } from "../../../../services/toast.service";
import PaginationButtons, { dataPagination } from "../../../PaginationButtons";
import Button, { ButtonGroup } from "../../../bootstrap/Button";
import Card, { CardHeader, CardLabel, CardTitle, CardActions, CardBody } from "../../../bootstrap/Card";
import Dropdown, { DropdownToggle, DropdownMenu, DropdownItem } from "../../../bootstrap/Dropdown";
import OffCanvas, { OffCanvasHeader, OffCanvasTitle, OffCanvasBody } from "../../../bootstrap/OffCanvas";
import Checks, { ChecksGroup } from "../../../bootstrap/forms/Checks";
import FormGroup from "../../../bootstrap/forms/FormGroup";
import Icon from "../../../icon/Icon";
import Input from "../../../bootstrap/forms/Input";
import { add } from "date-fns";


function FeeType() {

	useEffect(() => {
		getFeeTypeDetails();
	}, []);

	const { userAccountId, userTypeId, addAccess, editAccess, deleteAccess } = useContext(AuthContext);
	const { themeStatus, darkModeStatus } = useDarkMode();
	const [feeData, setFeeData] = useState([]);
	const [columnVisibilityData, setColumnVisibilityData] = useState([]);
	const [allColumnsData, setAllColumnsData] = useState([]);
	const [columnVisibilityMenu, setColumnVisibilityMenu] = useState(false);
	const [columnDataById, setColumnDataById] = useState([]);
	const componentRef = useRef(null);
	const [isChecked, setIsChecked] = useState(false);
	const [dataStatus, setDataStatus] = useState(false);

	// ForModal
	const [currentPage, setCurrentPage] = useState(1);
	const [perPage, setPerPage] = useState(10);
	const { items, requestSort, getClassNamesFor } = useSortableData(feeData);
	const onCurrentPageData = dataPagination(items, currentPage, perPage);
	const [addFeeOffCanvas, setAddFeeOffCanvas] = useState(false);
	const [editFeeOffCanvas, setEditFeeOffCanvas] = useState(false);
	const [isDeleteOpen, setIsDeleteOpen] = useState(false);



	// For Alert
	const [alertStatus, setAlertStatus] = useState<any>({ message: '', type: '' });
	const [isOpen, setIsOpen] = useState(false);
	const [noDataMsg, setNoDataMsg] = useState('');

	const feeForm = useFormik({
		enableReinitialize: true,
		initialValues: {
			feeType: '',
			description: '',
		},
		validate: (values) => {
			const errors: {
				feeType?: string;
			} = {};
			if (!values.feeType) {
				errors.feeType = 'Required';
			}
			return errors;
		},
		validateOnChange: true,
		onSubmit: () => {
			addFeeTypeSubmit();
		},
	});

	const editFeeTypeForm = useFormik({
		enableReinitialize: true,
		initialValues: {
			feeType: '',
			description: '',
			feeTypeId: '',
		},
		validate: (values) => {
			const errors: {
				feeType?: string;
				description?: string;
				feeTypeId?: number;
			} = {};
			if (!values.feeType) {
				errors.feeType = 'Required';
			}
			return errors;
		},
		validateOnChange: true,
		onSubmit: () => {
			updateFeeTypeSubmit();
		},
	});

	const columnVisibilityForm = useFormik({
		enableReinitialize: true,
		initialValues: {
			searchInput: '',
			available: false,
		},
		validate: (values) => { },
		//validateOnChange: false,
		onSubmit: () => { },
	});

	// Filter
	const filteredData = updateFilter(
		onCurrentPageData,
		columnVisibilityData,
		columnVisibilityForm,
	);

	function getFeeTypeDetails() {
		setDataStatus(false);
		getFeeType(
			(response) => {
				if (response.data.success) {
					let data = response.data.data.feeType;
					if (data != undefined) {
						getColumnsForTable('getFeeType', 'get');
						setFeeData(data);
						for (let i = 0; i < data.length; i++) {
							data[i].sno = i + 1;
						}
						setDataStatus(true);
					} else {
						setDataStatus(true);
						toasts('Undefined Data', 'Error');
					}
				} else if (response.data.success === false) {
					setDataStatus(true);
					//toasts(response.data.message, "Error")
					getColumnsForTable('getFeeType', 'get');
					setFeeData([]);
					setNoDataMsg(response.data.message);
				} else {
					let errorCode = response.data.error[0].error_code;
					let errorDescription = response.data.error[0].error_description;
					setDataStatus(true);
					toasts(errorDescription, 'Error');
				}
			},
			(error) => {
				setDataStatus(true);
				toasts(error, 'Error');
			},
		);
	}

	function onActivate(i: any) {
		if (i != undefined) {
			let selectedCaste = i;
			setEditFeeOffCanvas(true);

			editFeeTypeForm.setValues({
				feeType: selectedCaste.feeType,
				description: selectedCaste.description,
				feeTypeId: selectedCaste.feeTypeId,
			});
		}
	}

	function setFeeTypeDetails() {
		return {
			feeType: feeForm.values.feeType,
			description: feeForm.values.feeType,
			licenseKey: getLicenseKey,
			userAccountId: userAccountId,
		};
	}

	function setEditFeeTypeDetails() {
		return {
			feeTypeId: editFeeTypeForm.values.feeTypeId,
			feeType: editFeeTypeForm.values.feeType,
			description: editFeeTypeForm.values.feeType,
			userAccountId: userAccountId,
			isActive: 1,
			licenseKey: getLicenseKey,
		};
	}

	function addFeeTypeSubmit() {
		showLoader(true);
		if (feeForm.isValid) {
			let FeeTypePostData = setFeeTypeDetails();
			addFeeType(
				FeeTypePostData,
				(response) => {
					const data = response.data;
					if (data.success == true) {
						showLoader(false);
						setAlertStatus({ message: data.message, type: 'success' });
						setIsOpen(true);
						closeAndReset();
						getFeeTypeDetails();
					} else if (data.success == false) {
						showLoader(false);
						setAlertStatus({ message: data.message, type: 'error' });
						setIsOpen(true);
					} else {
						let errorCode = response.data.error[0].error_code;
						let errorDescription = response.data.error[0].error_description;
						showLoader(false);
						setAlertStatus({ message: errorDescription, type: 'error' });
						setIsOpen(true);
					}
				},
				(error) => {
					showLoader(false);
					setAlertStatus({ message: error, type: 'error' });
					setIsOpen(true);
				},
			);
		} else if (feeForm.isValid == false) {
			showLoader(false);
			setAlertStatus({ message: 'Please fill all the details!', type: 'error' });
			setIsOpen(true);
		}
	}

	function updateFeeTypeSubmit() {
		showLoader(true);
		if (editFeeTypeForm.isValid) {
			let FeeTypePostData = setEditFeeTypeDetails();
			updateFeeType(
				FeeTypePostData,
				(response) => {
					const data = response.data;
					if (data.success == true) {
						showLoader(false);
						setAlertStatus({ message: data.message, type: 'success' });
						setIsOpen(true);
						closeAndReset();
						getFeeTypeDetails();
					} else if (data.success == false) {
						showLoader(false);
						setAlertStatus({ message: data.message, type: 'error' });
						setIsOpen(true);
					} else {
						let errorCode = response.data.error[0].error_code;
						let errorDescription = response.data.error[0].error_description;
						showLoader(false);
						setAlertStatus({ message: errorDescription, type: 'error' });
						setIsOpen(true);
					}
				},
				(error) => {
					showLoader(false);
					setAlertStatus({ message: error, type: 'error' });
					setIsOpen(true);
				},
			);
		} else if (editFeeTypeForm.isValid == false) {
			showLoader(false);
			setAlertStatus({ message: 'Please fill all the details!', type: 'error' });
			setIsOpen(true);
		}
	}

	function deleteFeeTypeSubmit() {
		showLoader(true);
		let FeeTypePostData = setEditFeeTypeDetails();
		deleteFeeType(
			FeeTypePostData,
			(response) => {
				const data = response.data;
				if (data.success == true) {
					showLoader(false);
					setAlertStatus({ message: data.message, type: 'success' });
					setIsOpen(true);
					closeAndReset();
					getFeeTypeDetails();
				} else if (data.success == false) {
					showLoader(false);
					setAlertStatus({ message: data.message, type: 'error' });
					setIsOpen(true);
				} else {
					let errorCode = response.data.error[0].error_code;
					let errorDescription = response.data.error[0].error_description;
					showLoader(false);
					setAlertStatus({ message: errorDescription, type: 'error' });
					setIsOpen(true);
				}
			},
			(error) => {
				showLoader(false);
				setAlertStatus({ message: error, type: 'error' });
				setIsOpen(true);
			},
		);
	}

	function getColumnsForTable(apiName: any, type: any) {
		getColumnsForDataTable(
			userTypeId,
			apiName,
			(response) => {
				if (response.data.success) {
					let data = response.data.data.columnsForDataTable;
					if (data != undefined) {
						let allColumnsData = data;
						setAllColumnsData(allColumnsData);
						let columnVisibilityData = allColumnsData.filter(
							(item: any) => item.isDisplay == 1,
						);
						setColumnVisibilityData(columnVisibilityData);

						if (type == 'get') {
							const allData = allColumnsData.map((item: any) => item.isDisplay);
							const allColumns = allData.filter((item: any) => item == false);
							setIsChecked(allColumns == '' ? true : false);
						} else if (type == 'post') {
							const all = [];
							let nonDefaultValue = allColumnsData.filter(
								(item: any) => item.isDefault == false,
							);

							for (let i = 0; i < nonDefaultValue.length; i++) {
								const obj = {
									columnVisibilityId: nonDefaultValue[i].columnVisibilityId,
									isDisplay: nonDefaultValue[0].isDisplay == 0 ? 1 : 0,
								};
								all.push(obj);
							}
							updateColumnsSubmit('', '', all);
						}
					} else {
						toasts('Undefined Data', 'Error');
					}
				} else if (response.data.success === false) {
					toasts(response.data.message, 'Error');
				} else {
					let errorCode = response.data.error[0].error_code;
					let errorDescription = response.data.error[0].error_description;
					toasts(errorDescription, 'Error');
				}
			},
			(error) => {
				toasts(error, 'Error');
			},
		);
	}

	function updateColumnsSubmit(columnVisibilityId: any, isDisplay: any, type: any) {
		if (columnVisibilityForm.isValid) {
			setColumnDataById(isDisplay);
			const columnVisibilityPostData = {
				licenseKey: getLicenseKey,
				userAccountId: userAccountId,
				columns: type
					? type
					: [
						{
							columnVisibilityId: columnVisibilityId,
							isDisplay: isDisplay ? 0 : 1,
						},
					],
			};

			updateColumnsForDataTable(
				columnVisibilityPostData,
				(response) => {
					const data = response.data;
					if (data.success == true) {
						getColumnsForTable('getFeeType', 'get');
					} else if (data.success == false) {
						// toasts(data.success, "Error")
					} else {
						let errorCode = response.data.error[0].error_code;
						let errorDescription = response.data.error[0].error_description;
						toasts(errorDescription, 'Error');
					}
				},
				(error) => {
					toasts(error, 'Error');
				},
			);
		} else if (columnVisibilityForm.isValid == false) {
			toasts('Please fill all the details!', 'Error');
		}
	}

	function closeAndReset() {
		setAddFeeOffCanvas(false);
		setEditFeeOffCanvas(false);
		setIsDeleteOpen(false);
		feeForm.resetForm();
		editFeeTypeForm.resetForm();
	}

	// Print
	const handlePrint = useReactToPrint({
		content: () => componentRef.current,
	});

	return (
		<>
			<Card stretch data-tour='list' ref={componentRef}>
				<CardHeader borderSize={1}>
					<CardLabel icon='List' iconColor='info' className={addAccess ? 'col-lg-5' : 'col-lg-6'}>
						<CardTitle tag='div' className='h5'>
							Fee Type List
						</CardTitle>
					</CardLabel>
					&nbsp;&nbsp;
					<ButtonGroup className='col-lg-3 d-print-none' color='primary'>
						<Icon className='mt-1' icon='Search' size='2x' color='primary' />
						<Input
							id='searchInput'
							type='search'
							placeholder='Search...'
							onChange={columnVisibilityForm.handleChange}
							value={columnVisibilityForm.values.searchInput}
						/>
					</ButtonGroup>
					<CardActions className='d-print-none'>
						<Dropdown
							isOpen={columnVisibilityMenu}
							setIsOpen={setColumnVisibilityMenu}
							isButtonGroup>
							<DropdownToggle>
								<Button icon='FilterAlt' color='primary' isLight>
									Filter
								</Button>
							</DropdownToggle>
							<DropdownMenu isAlignmentEnd size='lg' isCloseAfterLeave={false}>
								<DropdownItem>
									<div className='container py-2'>
										<form className='row g-3'>
											<div className='col-12'>
												<FormGroup>
													<h6>Select All</h6>
													<Checks
														id='available'
														type='switch'
														label='Select All Columns'
														onChange={() =>
															getColumnsForTable(
																'getFeeType',
																'post',
															)
														}
														checked={isChecked}
														ariaLabel='Available status'
													/>
												</FormGroup>
											</div>
											<div
												className='col-12'
												style={{ maxHeight: '200px', overflowY: 'scroll' }}>
												<FormGroup>
													<h6>Columns</h6>
													<ChecksGroup>
														{allColumnsData.map((i: any) => (
															<Checks
																key={i.columnVisibilityId}
																id='{i.columnVisibilityId}'
																label={i.columnName}
																onChange={() =>
																	updateColumnsSubmit(
																		i.columnVisibilityId,
																		i.isDisplay,
																		'',
																	)
																}
																checked={i.isDisplay}
																disabled={i.isDefault == true}
															/>
														))}
													</ChecksGroup>
												</FormGroup>
											</div>
										</form>
									</div>
								</DropdownItem>
							</DropdownMenu>
						</Dropdown>
						<Dropdown isButtonGroup>
							<DropdownToggle>
								<Button color='primary' isLight icon='CloudDownload'>
									{' '}
									Export{' '}
								</Button>
							</DropdownToggle>
							<DropdownMenu isAlignmentEnd>
								<DropdownItem>
									<Button
										color='primary'
										isLight
										icon='CloudDownload'
										onClick={() =>
											downloadExcel(
												'FeeType',
												feeData,
												columnVisibilityData,
											)
										}>
										{' '}
										Excel{' '}
									</Button>
								</DropdownItem>
								<DropdownItem>
									<Button
										color='primary'
										isLight
										icon='PictureAsPdf'
										onClick={() =>
											convertJsonToPdf(
												feeData,
												columnVisibilityData,
												'FeeType',
											)
										}>
										{' '}
										PDF
									</Button>
								</DropdownItem>
								<DropdownItem>
									<Button
										color='primary'
										isLight
										icon='CloudDownload'
										onClick={() =>
											downloadFile('FeeType', feeData, columnVisibilityData)
										}>
										{' '}
										CSV{' '}
									</Button>
								</DropdownItem>
								<DropdownItem>
									<Button
										color='primary'
										isLight
										icon='Print'
										onClick={handlePrint}>
										{' '}
										Print{' '}
									</Button>
								</DropdownItem>
							</DropdownMenu>
						</Dropdown>
						{addAccess ?
							<Button
								color='primary'
								icon='Add'
								isLight
								onClick={() => setAddFeeOffCanvas(true)}>
								Add New
							</Button>
							: null
						}
					</CardActions>
				</CardHeader>

				<CardBody className='table-responsive' isScrollable>
					{!dataStatus ? (
						<TableLoader />
					) : (
						<table className='table table-modern table-hover text-nowrap'>
							<thead>
								<tr>
									<th
										scope='col'
										onClick={() => requestSort('sno')}
										className='cursor-pointer text-decoration-underline'>
										S.No{' '}
										<Icon
											size='lg'
											className={getClassNamesFor('sno')}
											icon='FilterList'
										/>
									</th>
									{columnVisibilityData.map((column: any) => (
										<th
											key={column.keyName}
											scope='col'
											onClick={() => requestSort(column.keyName)}
											className='cursor-pointer text-decoration-underline'>
											{column.columnName}
											<Icon
												size='lg'
												className={getClassNamesFor(column.keyName)}
												icon='FilterList'
											/>
										</th>
									))}
									{editAccess ?
										<th scope='col' className='d-print-none'>
											Action
										</th>
										: null
									}
								</tr>
							</thead>
							<tbody>
								{filteredData != '' ? (
									<>
										{filteredData.map((rowData: any) => (
											<tr key={rowData.feeTypeId}>
												<td>{rowData.sno}</td>
												{columnVisibilityData.map((column: any) =>
													column.isDisplay && rowData[column.keyName] ? (
														<td
															key={`${rowData.feeTypeId}-${column.keyName}`}>
															{rowData[column.keyName]}
														</td>
													) : (
														<td key={`empty-${column.keyName}`} />
													),
												)}
												{editAccess ?
													<td className='d-print-none'>
														<Button
															color='dark'
															isLight
															icon='Edit'
															aria-label='Edit'
															onClick={() => {
																onActivate(rowData);
															}}
														/>
													</td>
													: null
												}
											</tr>
										))}
									</>
								) : (
									<NoDataMsg
										columnsCount={columnVisibilityData.length + 2}
										msg={noDataMsg}
									/>
								)}
							</tbody>
						</table>
					)}
				</CardBody>
				<PaginationButtons
					className='d-print-none'
					data={items}
					label='items'
					setCurrentPage={setCurrentPage}
					currentPage={currentPage}
					perPage={perPage}
					setPerPage={setPerPage}
				/>
			</Card>

			<OffCanvas
				setOpen={setAddFeeOffCanvas}
				isOpen={addFeeOffCanvas}
				titleId='addFeeOffCanvas'
				isBodyScroll
				placement='end'
				tag='form'
				noValidate
				onSubmit={feeForm.handleSubmit}>
				<OffCanvasHeader setOpen={setAddFeeOffCanvas} onClick={closeAndReset}>
					<OffCanvasTitle id='addFeeOffCanvas'>Fee Type Creation</OffCanvasTitle>
				</OffCanvasHeader>
				<OffCanvasBody>
					<div className='row g-4'>
						<div className='col-12'>
							<FormGroup id='feeType' label='Fee Type'>
								<Input
									onChange={feeForm.handleChange}
									value={feeForm.values.feeType}
									isValid={feeForm.isValid}
									onBlur={feeForm.handleBlur}
									isTouched={feeForm.touched.feeType}
									invalidFeedback={feeForm.errors.feeType}
									placeholder='Enter Fee Type'
								/>
							</FormGroup>
						</div>
					</div>
				</OffCanvasBody>
				<div className='row m-0'>
					<div className='col-12 p-3'>
						<Button
							color='info'
							icon='Save'
							className='w-100'
							type='submit'
							isDisable={!feeForm.isValid && !!feeForm.submitCount}>
							Save
						</Button>
					</div>
				</div>
			</OffCanvas>

			<OffCanvas
				setOpen={setEditFeeOffCanvas}
				isOpen={editFeeOffCanvas}
				titleId='editFeeOffCanvas'
				isBodyScroll
				placement='end'
				tag='form'
				noValidate
				onSubmit={editFeeTypeForm.handleSubmit}>
				<OffCanvasHeader setOpen={setEditFeeOffCanvas} onClick={closeAndReset}>
					<OffCanvasTitle id='editFeeOffCanvas'>Update Fee Type</OffCanvasTitle>
				</OffCanvasHeader>
				<OffCanvasBody>
					<div className='row g-4'>
						<div className='col-12'>
							<FormGroup id='feeType' label='Fee Type'>
								<Input
									onChange={editFeeTypeForm.handleChange}
									value={editFeeTypeForm.values.feeType}
									isValid={editFeeTypeForm.isValid}
									onBlur={editFeeTypeForm.handleBlur}
									isTouched={editFeeTypeForm.touched.feeType}
									invalidFeedback={editFeeTypeForm.errors.feeType}
									placeholder='Enter Fee Type'
								/>
							</FormGroup>
						</div>
					</div>
				</OffCanvasBody>

				<div className='row'>
					<div className='d-flex justify-content-center position-absolute top-65 start-50 translate-middle'>
						<DeleteComponents
							isDeleteOpen={isDeleteOpen}
							setIsDeleteOpen={setIsDeleteOpen}
							deleteFunction={deleteFeeTypeSubmit}
						/>
					</div>
					{deleteAccess ?
						<div className='col-6 position-absolute bottom-0 start-0 p-3'>
							<Button
								color='danger'
								className='w-100'
								icon='Delete'
								onClick={() => setIsDeleteOpen(!isDeleteOpen)}>
								Delete
							</Button>
						</div>
						: null
					}
					<div className={deleteAccess ? 'col-6 position-absolute bottom-0 end-0 p-3' : 'col-6 position-absolute bottom-0 start-0 p-3'}>
						<Button
							color='info'
							icon='Save'
							type='submit'
							className='w-100'
							isDisable={!editFeeTypeForm.isValid && !!editFeeTypeForm.submitCount}>
							{' '}
							Update
						</Button>
					</div>
				</div>
			</OffCanvas>

			<AlertService setIsOpen={setIsOpen} isOpen={isOpen} alertStatus={alertStatus} />
		</>
	);
}
export default FeeType;
